import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material';
import IconCancel from '@mui/icons-material/Cancel';
import IconSave from '@mui/icons-material/Save';
import { useState } from 'react';
import { useNotify, useRefresh } from 'react-admin';
import UserHandler from '../../react-admin/providers/handlers/UserHandler';
import dayjs from 'dayjs';

const usePauseCollections = ({ setShow, userId }: { setShow: (flag: boolean) => void; userId: string | undefined }) => {
  const [loading, setLoading] = useState(false);
  const [reason, setReason] = useState('');
  const [date, setDate] = useState('');
  const [days, setDays] = useState<number>();

  const notify = useNotify();

  const refresh = useRefresh();
  const close = () => {
    setReason('');
    setLoading(false);
    setShow(false);
  };
  const unlock = async () => {
    setLoading(true);
    if (userId != null) {
      UserHandler.pauseCollections(
        userId,
        date,
        reason,
        () => {
          refresh();
          close();
        },
        (e: any) => {
          notify(e.toString(), { type: 'error' });
          close();
        }
      );
    } else {
      close();
    }
  };

  const onSetDays = (event: any) => {
    setDays(event.target.value);
    setDate(dayjs().add(parseInt(event.target.value), 'day').format('YYYY-MM-DD'));
  };

  return {
    reason,
    setReason: (event: any) => setReason(event.target.value),
    date,
    setDate: (event: any) => setDate(event.target.value),
    unlock,
    close,
    loading,
    days,
    setDays: onSetDays,
  };
};

export const PauseCollectionsAction = ({ user }: { user: any }) => {
  const [show, setShow] = useState(false);
  const { unlock, close, loading, reason, setReason, date, setDate, days, setDays } = usePauseCollections({
    setShow,
    userId: user.id,
  });
  return (
    <>
      <Button color="primary" onClick={() => setShow(true)}>
        Pause collections
      </Button>
      <Dialog fullWidth open={show} onClose={setShow} aria-label="Cancel">
        <DialogTitle>Unlock</DialogTitle>
        <DialogContent>
          <Grid item xs={12}>
            <span>
              <b>Attention!</b>
              <br />
              <br />
              You are about to pause collections for the customer.
              <br />
              <br />
              Are you sure you want to proceed?
            </span>
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="reason"
              placeholder="Reason"
              variant="outlined"
              fullWidth
              value={reason}
              onChange={setReason}
            />
          </Grid>
          <Grid container={true} spacing={2}>
            <Grid item xs={6}>
              <div>Date until</div>
            </Grid>
            <Grid item xs={6}>
              Days
            </Grid>
          </Grid>
          <Grid container={true} spacing={2}>
            <Grid item xs={6}>
              <TextField
                id="date"
                placeholder="Date until"
                variant="outlined"
                value={date}
                onChange={setDate}
                type={'date'}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                id="days"
                placeholder="Days"
                variant="outlined"
                value={days}
                onChange={setDays}
                type={'number'}
                InputProps={{ inputProps: { min: 0, max: 30 } }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={close} disabled={loading}>
            <IconCancel />
            <span>No</span>
          </Button>
          <Button onClick={unlock} disabled={reason === '' || date === '' || loading}>
            <IconSave />
            <span>Yes</span>
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
